export default __webpack_public_path__ + "static/media/asset-detail-iv-audio@3x.b4408bdc.png";